import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
   getCurrentUserIsAdminUser,
   getCurrentUserIsSystemUser,
} from 'src/app/authentication/state/authentication.selector';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { AddUserData } from 'src/app/pages/add-user/models/add-user-data';
import { getAddUserCallState } from 'src/app/pages/add-user/state/add-user.selectors';
import { getSelectedAccount } from 'src/app/store/select-account/select-account.selector';
import { UserDetailFormService } from '../../user-details/services/user-detail-form.service';
import * as UserRegisterActions from '../../user-register/state/user-register.reducer';
import { createUser } from '../state/add-user.actions';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [UserDetailFormService],
    selector: 'ndt-add-user',
    styleUrls: ['./add-user.component.scss'],
    templateUrl: './add-user.component.html',
    standalone: false
})
export class AddUserComponent implements OnInit, OnDestroy, FormComponent {
   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   isSystemUser$: Observable<boolean>;
   isAdminUser$: Observable<boolean>;

   public fromAccount: boolean;

   numberOfUsers$: Observable<number>;

   constructor(
      protected store: Store,
      protected formService: UserDetailFormService,
      protected router: Router,
      @Inject(MAT_DIALOG_DATA) public data: AddUserData,
      private dialogService: LcsDialogService
   ) {
      this.isSystemUser$ = this.store.pipe(select(getCurrentUserIsSystemUser));
      this.isAdminUser$ = this.store.pipe(select(getCurrentUserIsAdminUser));
      this.callState = this.store.pipe(select(getAddUserCallState));
      this.numberOfUsers$ = this.store.pipe(select(UserRegisterActions.selectTotalCount));
   }

   ngOnInit(): void {
      this.form = this.formService.form;
      this.store
         .select(getSelectedAccount)
         .pipe(takeUntil(this.destroyed$))
         .subscribe((account) => {
            if (!this.router.url.includes('systemusers')) {
               this.form.patchValue({ account: account });
               this.fromAccount = true;
            }
         });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createUser({
               user: this.formService.getValue(null),
            })
         );
      }
   }
}
